module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAPtJREFUWAntlz0OgkAQhd+wewETOigsrLyBl9BKpTAewp7ecBJ/Kk7hDTyBdiRcQBhngayUNCyJWQoybMh+b18ymX3Eh3iBilPUmMHlE6AEVKZbOB9dshtWbd6fubYnJ3qB8XAihLACcyysUFugwOn63tnvEQveRzfZfmsQwYicQVt7Ad4B78CgVvE//bUDxEmUymBIJjkl0UXLBDQDaDmJAGFrKDqjwmYSAYrySbge2nfAdEEuXbAG6O72RsTmRvQMpAuor8h17aehd8A78EtGEpe6xDJ+JzbRrMVoyUal5EN0Wa2JS6MrYEsoxAGVmZQqS6FddlMUUPr0BaLnPZshtj3UAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/scan.png
// module id = 76TK
// module chunks = 53